import React, { useState } from 'react';
import Fade from 'react-reveal/Fade';
import { useSite } from '../context/SiteContext';
import { websiteData } from '../data/data';
import '../styles/contact.scss';

function Contact() {
  const { settings } = useSite();
  const { contactPage } = websiteData;

  return (
    <div id='contactPage' style={{ background: '#fff' }}>
      {/* 1. NAVBAR SPACER & HERO SECTION */}
      <div style={{ height: '74px', background: '#fff' }} />
      
      <section className="contact-hero" style={{ 
        position: 'relative', 
        padding: '140px 0 110px', 
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${contactPage.customerImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        color: '#fff',
        textAlign: 'center',
        overflow: 'hidden'
      }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <Fade bottom>
                <span className="eyebrow" style={{ 
                  color: '#ff4400', 
                  fontWeight: '800', 
                  letterSpacing: '4px', 
                  fontSize: '13px',
                  display: 'block',
                  marginBottom: '16px',
                  textTransform: 'uppercase'
                }}>CONTACT US</span>
                <h1 style={{ 
                  fontSize: 'clamp(40px, 6vw, 64px)', 
                  fontWeight: '900', 
                  lineHeight: '1.1',
                  color: '#fff',
                  marginBottom: '24px',
                  letterSpacing: '-0.04em'
                }}>
                  We're here to <br/>
                  <span style={{ color: '#ff4400' }}>help you grow.</span>
                </h1>
                <p style={{ 
                  fontSize: '19px', 
                  color: 'rgba(255, 255, 255, 0.9)', 
                  lineHeight: '1.6',
                  maxWidth: '640px',
                  margin: '0 auto 40px'
                }}>
                  {contactPage.heroSub}
                </p>
              </Fade>
            </div>
          </div>
        </div>
      </section>

      {/* 2. ZOHO FORM SECTION */}
      <section style={{ padding: '100px 20px', background: '#fff' }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          <Fade bottom>
            <div style={{ textAlign: 'center', marginBottom: '60px' }}>
              <h2 style={{ fontSize: '32px', fontWeight: '800', color: '#101828', marginBottom: '16px' }}>{contactPage.formTitle}</h2>
              <p style={{ color: '#475467', fontSize: '17px' }}>{contactPage.formSub}</p>
            </div>
            
            <div style={{ 
              borderRadius: '32px', 
              overflow: 'hidden', 
              boxShadow: '0 20px 48px rgba(0,0,0,0.08)',
              border: '1px solid rgba(0,0,0,0.05)',
              background: '#fff'
            }}>
              <iframe
                src={contactPage.formUrl}
                title="Contact Form"
                width="100%"
                height="850px"
                style={{ border: 'none' }}
              />
            </div>
          </Fade>
        </div>
      </section>

      {/* 3. SUPPORT CHANNELS (WHATSAPP, LIVE AGENT & OFFICE ADDRESS) */}
      <section style={{ padding: '100px 20px', background: '#fcfcfd' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="row g-4">
                <div className="col-lg-4 col-md-6">
                  <Fade bottom delay={100}>
                    <div style={{ 
                      padding: '48px 32px', 
                      background: '#fff', 
                      borderRadius: '32px', 
                      border: '1px solid rgba(0,0,0,0.05)',
                      height: '100%',
                      textAlign: 'center',
                      transition: 'all 0.3s ease'
                    }} className="support-card">
                      <div style={{ 
                        width: '64px', 
                        height: '64px', 
                        background: '#e7f5ed', 
                        borderRadius: '16px', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        margin: '0 auto 24px'
                      }}>
                        <img src="/whatsapp.png" alt="WhatsApp" style={{ width: '32px' }} onError={(e) => e.target.src = 'https://cdn-icons-png.flaticon.com/512/733/733585.png'} />
                      </div>
                      <h3 style={{ fontSize: '24px', fontWeight: '800', color: '#101828', marginBottom: '12px' }}>WhatsApp Support</h3>
                      <p style={{ color: '#475467', marginBottom: '32px' }}>Chat with us instantly on WhatsApp for quick resolutions.</p>
                      <a 
                        href={settings.whatsapp_url || 'https://wa.me/2349012345678'} 
                        target="_blank" 
                        rel="noreferrer"
                        className="waya-btn-primary"
                        style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}
                      >
                        Start Chat
                      </a>
                    </div>
                  </Fade>
                </div>

                <div className="col-lg-4 col-md-6">
                  <Fade bottom delay={200}>
                    <div style={{ 
                      padding: '48px 32px', 
                      background: '#fff', 
                      borderRadius: '32px', 
                      border: '1px solid rgba(0,0,0,0.05)',
                      height: '100%',
                      textAlign: 'center',
                      transition: 'all 0.3s ease'
                    }} className="support-card">
                      <div style={{ 
                        width: '64px', 
                        height: '64px', 
                        background: '#fff5f0', 
                        borderRadius: '16px', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        margin: '0 auto 24px'
                      }}>
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ff4400" strokeWidth="2">
                          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                        </svg>
                      </div>
                      <h3 style={{ fontSize: '24px', fontWeight: '800', color: '#101828', marginBottom: '12px' }}>Live Agent</h3>
                      <p style={{ color: '#475467', marginBottom: '32px' }}>Speak directly with one of our friendly customer success agents.</p>
                      <button
                        onClick={() => window.wayaChat && window.wayaChat.open()}
                        className="waya-btn-secondary"
                        style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}
                      >
                        Talk to an Agent
                      </button>
                    </div>
                  </Fade>
                </div>

                <div className="col-lg-4 col-md-12">
                  <Fade bottom delay={300}>
                    <div style={{ 
                      padding: '48px 32px', 
                      background: '#fff', 
                      borderRadius: '32px', 
                      border: '1px solid rgba(0,0,0,0.05)',
                      height: '100%',
                      textAlign: 'center',
                      transition: 'all 0.3s ease'
                    }} className="support-card">
                      <div style={{ 
                        width: '64px', 
                        height: '64px', 
                        background: '#fff3eb', 
                        borderRadius: '16px', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        margin: '0 auto 24px'
                      }}>
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ff4400" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                          <circle cx="12" cy="10" r="3" />
                        </svg>
                      </div>
                      <h3 style={{ fontSize: '24px', fontWeight: '800', color: '#101828', marginBottom: '12px' }}>Office Address</h3>
                      <p style={{ color: '#475467', marginBottom: '16px', lineHeight: '1.6', fontSize: '15px' }}>
                        14 Yeye olofin street<br />
                        Lekki, Lagos<br />
                        Nigeria
                      </p>
                      <span style={{ fontSize: '14px', color: '#ff4400', fontWeight: '600' }}>
                        Visit Us
                      </span>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        .support-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 24px 48px rgba(0,0,0,0.06);
          border-color: #ff440022;
        }
        .waya-btn-secondary {
          background: #fff;
          border: 1px solid #d0d5dd;
          color: #344054;
          padding: 12px 24px;
          border-radius: 8px;
          font-weight: 600;
          transition: all 0.3s ease;
        }
        .waya-btn-secondary:hover {
          background: #f9fafb;
          border-color: #98a2b3;
        }
        @media (max-width: 768px) {
          .contact-hero {
            padding: 100px 0 70px !important;
          }
          .support-card {
            padding: 32px 20px !important;
          }
          iframe {
            height: 950px !important; /* Give more height for wrapped form on mobile */
          }
        }
      `}</style>
    </div>
  );
}

export default Contact;
